/** 部分签收 */

/** 服务产品支持的签收服务类型 */
export const SIGN_PART_TYPE = {
  YES: '1',
  NO: '0',
}

/** 服务产品支持的签收服务类型 */
export const SIGN_PART_TYPE_OPTIONS = [
  {
    label: 'component.serviceProvider.signPartYes',
    value: SIGN_PART_TYPE.YES,
  },
  {
    label: 'component.serviceProvider.signPartNo',
    value: SIGN_PART_TYPE.NO,
  },
]
